import PropTypes from 'prop-types';

import {black500, blue500} from "assets/jss/main";

SuggestionBox.propTypes = {
    text: PropTypes.string.isRequired,
};

function SuggestionBox({text}) {
    return (
        <div
            style={{
                backgroundColor: '#f5f9ff',
                border: '1px solid #e2edfe',
                borderRadius: '4px',
                padding: '12px',
                marginTop: '16px'
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    color: blue500,
                    fontSize: '12px',
                    fontWeight: '500',
                }}
            >
                <span>💡</span>Suggestion IA
            </div>
            <p style={{margin: 0, fontSize: '14px', color: black500}}>
                {text}
            </p>
        </div>
    );
}

export default SuggestionBox;
